/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lost_Aloof_Gadfly_NailInputs */

const en_lost_aloof_gadfly_nail = /** @type {(inputs: Lost_Aloof_Gadfly_NailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No roles found`)
};

const de_lost_aloof_gadfly_nail = /** @type {(inputs: Lost_Aloof_Gadfly_NailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rollen gefunden`)
};

/**
* | output |
* | --- |
* | "No roles found" |
*
* @param {Lost_Aloof_Gadfly_NailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lost_aloof_gadfly_nail = /** @type {((inputs?: Lost_Aloof_Gadfly_NailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lost_Aloof_Gadfly_NailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lost_aloof_gadfly_nail(inputs)
	return de_lost_aloof_gadfly_nail(inputs)
});